import * as useCases from 'core/use-cases';
import { takeLatest } from 'core/middlewares/utilities';

import * as workflows from './workflows';
/**
 * Map use-cases request action types to corresponting BFF endpoints
 *
 */
export const actions = [
  [useCases.app.actions.preflightFlow.type, workflows.preflightFlow, takeLatest],
  [useCases.user.actions.userResaleIntention.success.type, workflows.userInit, takeLatest],
  [useCases.user.actions.userFetch.success.type, workflows.appInit, takeLatest],
  [useCases.user.actions.cyclesFetch.success.type, workflows.redirectFlow, takeLatest],
  [useCases.user.actions.changeCycle.success.type, workflows.bffInit, takeLatest],
  [useCases.user.actions.changeCycle.failure.type, workflows.bffInit, takeLatest],
  [
    useCases.extendedCaptation.actions.extendedCaptationNotAvailable.type,
    workflows.redirectLogin,
    takeLatest,
  ],
  [useCases.extendedCaptation.actions.goToHome.type, workflows.redirectLogin, takeLatest],
  [
    (action: useCases.utilities.Action) =>
      action.type.endsWith(useCases.utilities.REQUEST_STATE.FAILURE),
    workflows.errorFlow,
    takeLatest,
  ],
  [
    (action: useCases.utilities.Action) =>
      action.type.endsWith(useCases.utilities.REQUEST_STATE.REQUEST),
    workflows.requestFlow,
    takeLatest,
  ],
  [
    (action: useCases.utilities.Action) =>
      action.type.endsWith(useCases.utilities.REQUEST_STATE.SUCCESS),
    workflows.successFlow,
    takeLatest,
  ],
  [useCases.cart.actions.cartCleanUp.type, workflows.cartCleanUp, takeLatest],
  [
    useCases.catalog.actions.catalogFetch.success,
    workflows.redirectEmptyRecommendation,
    takeLatest,
  ],
  [useCases.cart.actions.checkoutRedirectFlow.type, workflows.checkoutRedirect, takeLatest],
  [useCases.cart.actions.giftsFlowCheck.type, workflows.giftsFlowCheck, takeLatest],
  [useCases.cart.actions.cartFetch.success.type, workflows.processFetch, takeLatest],
  [useCases.checkout.actions.promotionFetch.success.type, workflows.checkoutInit, takeLatest],
  [useCases.checkout.actions.checkoutInit.type, workflows.giftInit, takeLatest],
  [useCases.checkout.actions.paymentDetailFetch.success.type, workflows.confirmation, takeLatest],
  [useCases.checkout.actions.reloadPaymentMethods.type, workflows.cartInit, takeLatest],
  [
    useCases.checkout.actions.paymentMethodsFetch.success.type,
    workflows.isPaymentCanSubmit,
    takeLatest,
  ],
  [useCases.cart.actions.cartFetch.success.type, workflows.retryOrder, takeLatest],
  [useCases.order.actions.orderFetch.success.type, workflows.retryOrder, takeLatest],
] as const;
